export default "__VITE_ASSET__CJwU7kEL__"